// =====================================
//
//   報價單 相關功能 Service
//   Author: Gray
//   createtime: 2017 / 07 / 26
//   updatetime: 2017 / 07 / 26
//
// =====================================

window.InifECApp.factory("SpecialOfferService", ['$q', '$http', 'Upload', function($q, $http, Upload) {

    var factory = {};

    // --------------------------------
    // 建立報價單 （非會員也可以報價）
    // --------------------------------
    var createSpecialOffer = function(productName, pdtClass, spec, processRemark, userRemark, contactName, contactEmail, contactPhone) {

       var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/SpecialOfferAction.do",
            method: "POST",
            data: $.param({
                op: "createSpecialOffer",
                productName: productName,
                pdtClass: pdtClass,
                spec: spec,
                processRemark: processRemark,
                userRemark: userRemark,
                contactName: contactName,
                contactEmail: contactEmail,
                contactPhone: contactPhone,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : SpecialOfferService.createSpecialOffer request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得會員報價單資訊
    // --------------------------------
    var getMemberSpecialOffer = function(specialofferid) {

        var defer = $q.defer();

        $http({
            url: "/SpecialOfferAction.do",
            method: "GET",
            params: {
                op: "getMemberSpecialOffer",
                specialofferid: specialofferid,
            }
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }            
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : SpecialOfferService.getMemberSpecialOffer request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得會員報價單列表
    // --------------------------------
    var getMemberSpecialOfferList = function(specialOfferStatus, start, len, startdate, enddate) {

        var defer = $q.defer();

        $http({
            url: "/SpecialOfferAction.do",
            method: "GET",
            params: {
                op: "getMemberSpecialOfferList",
                specialOfferStatus: specialOfferStatus,
                start: start,
                len: len,
                startdate: startdate,
                enddate: enddate,
            }
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }            
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : SpecialOfferService.getMemberSpecialOfferList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 上傳報價單檔案
    // ------------------------------
    var uploadSpecialOfferFile = function(specialofferid, offeritemid, file) {

        var defer = $q.defer();

        // 超過單檔上限就不送（大檔還會被 nginx 413 擋下，而 413 不帶 CORS header，前端只看得到網路錯誤）
        if (!checkUploadFileSize(file)) {
            defer.reject({code: 'error.upload.fileTooLarge'});
            return defer.promise;
        }

        file.progress = 0;

        var fd = new FormData();

        fd.append('op', 'uploadSpecialOfferFile');
        fd.append('file', file);
        fd.append('specialofferid', specialofferid);
        fd.append('offeritemid', offeritemid);
        fd.append('filename', file.name);

        // 分流到 upload 子網域時，先確認登入等條件都正常才開始傳（見 global.js 的 precheckUploadServlet）
        var defaultUploadUrl = SECURE_INIFEC_URL + "/UploadServlet";
        var uploadUrl = getUploadServletUrl(defaultUploadUrl, file);

        precheckUploadServlet($http, $q, uploadUrl, defaultUploadUrl, 'uploadSpecialOfferFile').then(function() {

            Upload.http({
                url: uploadUrl, 
                data: fd,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined},            
                withCredentials: true
            })
            // $http.post("/UploadServlet", fd, {
            //     transformRequest: angular.identity,
            //     headers: {'Content-Type': undefined}
            // })
            .progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = percent;
            })
            .success(function(data){
                if (data.error) {
                    defer.reject(data.error);
                } else {                                    
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : SpecialOfferService.uploadSpecialOfferFile error.");
                console.error("status : " + status);
            });

        }, function(error) {
            defer.reject(error);
            console.error("[InifEC Error] : 大檔上傳前的檢查失敗", error);
        });

        return defer.promise;
    }

    // --------------------------------
    // 作廢會員的報價單
    // --------------------------------
    var discardMemberSpecialOffer = function(specialofferid) {

       var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/SpecialOfferAction.do",
            method: "POST",
            data: $.param({
                op: "discardMemberSpecialOffer",
                specialofferid: specialofferid,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : SpecialOfferService.discardMemberSpecialOffer request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/

    /*==========================
        Methods
    ==========================*/
    // 建立報價單 （非會員也可以報價）
    factory.createSpecialOffer = createSpecialOffer;
    // 取得會員報價單資訊
    factory.getMemberSpecialOffer = getMemberSpecialOffer;
    // 取得會員報價單列表
    factory.getMemberSpecialOfferList = getMemberSpecialOfferList;
    // 上傳報價單檔案
    factory.uploadSpecialOfferFile = uploadSpecialOfferFile;
    // 作廢會員的報價單
    factory.discardMemberSpecialOffer = discardMemberSpecialOffer;

    return factory;
}]);